import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TecRMIBusinessService } from 'projects/Administration/src/app/business-services/Tec-RMI.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PartViewModel, WorkViewModel } from 'projects/Administration/src/app/business-entities/tecrmi-model';

@Component({
  selector: 'app-tec-rmi-part-detail',
  templateUrl: './tec-rmi-part-detail.component.html'
})
export class TecRmiPartDetailComponent implements OnInit {
  partList: PartViewModel[];
  @Input() tecDocType: number;
  @Input() workStepId: number;
  @Input() workPartList: PartViewModel[];
  @Output() addCartPart = new EventEmitter<PartViewModel>();
  @Output() removeCartPart = new EventEmitter<PartViewModel>();
  @Output() setPartsToWork = new EventEmitter<WorkViewModel>();

  constructor(
    private tecRMIService: TecRMIBusinessService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.initialize();
  }

  initialize() {
    this.getPartDetails();
  }

  getPartDetails() {
    if (this.workPartList) {
      this.partList = this.workPartList;
    }
    if (!this.partList) {
      this.spinner.show();
      this.tecRMIService.getPartsForWork(this.tecDocType, this.workStepId).then(result => {
        if (result) {
          this.partList = result.responseObject;
          let work: any = {
            workId: this.workStepId,
            parts: this.partList
          };
          this.setPartsToWork.emit(work);
        }
        this.spinner.hide();
      },
      _error => {
          this.spinner.hide();
        });
    }
  }

  ManageCartParts(event) {
    let partItemMpId = event.target.value;
    if (event.target.checked) {
      this.partList.forEach(element => {
        if (element.itemMpId == partItemMpId) {
          this.addCartPart.emit(element);
        }
      });
    }
    else {
      this.partList.forEach(element => {
        if (element.itemMpId == partItemMpId) {
          this.removeCartPart.emit(element);
        }
      });
    }

  }
}
